import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class Button extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    attributes: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    component: null,
    attributes: "",
    events: "",
    caption: "",
  };

  constructor(props) {
    super(props);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }
    this.state = {
      events: events,
    };
  }

  componentDidMount() {
    this.setState({
      defaultValue: this.props.value,
      attributes: this.props.property.attributes,
      caption: this.props.property.caption,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  render() {
    return (
      <button type="button" {...this.state.attributes} {...this.state.events}>
        {this.state.caption}
      </button>
    );
  }
}

export default withRouter(Button);
